import React, {Component} from "react";
import {connect} from "react-redux";

import {setLegendStateAction} from "./../../actions/SettingsAction";
import SVGIcon from "./../svg/SVGIcon";

import "./MapLegend.css";

class MapLegend extends Component {

  constructor(props){
    super(props);
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen(){
    const {open, setLegendState} = this.props;
    setLegendState(!open);
  }

  render() {
    const {open, legendOptions } = this.props;

    return (
      <div id="fow-legend" className={open ? 'fow-legend-open' : 'fow-legend-closed'}>
        <div id="fow-legend-action" onClick={this.toggleOpen}>
          {open &&
            <span><SVGIcon name="collapse" height="20" width="20" fill="#444"/></span>
          }
          {!open &&
            <span><SVGIcon name="reference" strokeWidth="2" height="25" width="25" stroke="#051C2C" fill="#051C2C" /></span>
          }
        </div>
        {open &&
          <div>
            <div id="fow-legend-title" className="fow-font-text fow-font-size-md">{legendOptions.title}</div>
            {legendOptions.subtitle &&
              <div id="fow-legend-subtitle" className="fow-font-text fow-font-size-xs">{legendOptions.subtitle}</div>
            }
            <div id="fow-legend-item-container">
              {legendOptions.items.filter(lo => lo[0] !== '').map((c,ix) =>
                <div key={ix} className="fow-legend-item">
                  <div className="fow-legend-item-color" style={{backgroundColor: c[1]}}></div>
                  <div className="fow-legend-item-label fow-font-text fow-font-size-xs">{c[0]}</div>
                </div>
              )}
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    open: state.settings.legendOpen,
    legendOptions: state.db.map.legend,
  };
};
const mapDispatchToProps = dispatch => ({
  setLegendState: open => dispatch(setLegendStateAction(open)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapLegend);
